import type { TextFieldProps } from '@mui/material';
import { FormHelperText, InputAdornment, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

import { LockIcon, TimeIcon } from '../../assets/assets';
import { TimeInputStyled } from './TimeInput.styled';

export type TimeInputProps = TextFieldProps & {
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  errorMessage?: string;
};

export const TimeInput: FC<TimeInputProps> = ({
  startAdornment,
  endAdornment,
  disabled,
  errorMessage,
  ...props
}) => {
  const defaultStartAdornment = startAdornment ?? (
    <InputAdornment position="start">
      <TimeIcon />
    </InputAdornment>
  );

  const renderEndAdornment = () => {
    if (endAdornment) return endAdornment;
    if (disabled) {
      return (
        <InputAdornment position="end">
          <LockIcon />
        </InputAdornment>
      );
    }
  };

  return (
    <>
      <TimeInputStyled
        type="time"
        disabled={disabled}
        InputProps={{
          startAdornment: defaultStartAdornment,
          endAdornment: renderEndAdornment(),
        }}
        InputLabelProps={{
          sx: {
            ml: 3.5,
            visibility: props.value ? 'hidden' : 'visible',
            '&.Mui-focused': {
              visibility: 'hidden',
            },
          },
        }}
        {...props}
        required={false}
      />
      {errorMessage && (
        <FormHelperText>
          <Typography variant="body2" color="error.main">
            {errorMessage}
          </Typography>
        </FormHelperText>
      )}
    </>
  );
};
